"use client";
import FormModal from "@/components/common/form-modal";
import { useModalContext } from "@/contexts/ModalContext";

interface FormModalClientProps {
    defaultTitle: string;
    defaultSlug: string;
}

const FormModalClient = ({
    defaultTitle,
    defaultSlug,
}: FormModalClientProps) => {
    const modal = useModalContext();

    const getSubmitButtonText = (title: string) => {
        const lowerTitle = title.toLowerCase();
        if (lowerTitle.includes("download") || lowerTitle.includes("downlode")) {
            return "Download";
        }
        return "Request";
    };
    return (
        <FormModal
            isOpen={modal.isOpen}
            onClose={modal.closeModal}
            onSubmit={() => {
                modal.closeModal();
            }}
            title={modal.modalTitle || defaultTitle}
            submitButtonText={getSubmitButtonText(modal.modalTitle || defaultTitle)}
            dialogSlug={modal.modalTitle || defaultSlug}
        />
    );
};

export default FormModalClient;
